// extracted by mini-css-extract-plugin
export default {"file-card":"style_file-card__pLsQM"};